const DEFAULT_SPINNER_URL = 'https://static-hosting.spinviewglobal.com/hs_spinner.png';
const DEFAULT_OPTIONS = {
	size: 100,
	url: DEFAULT_SPINNER_URL,
};

function SpinnerHotspot(krpano, name, options = {}) {
	options ={
		...DEFAULT_OPTIONS,
		...options,
	};

	if (!options.url) {
		options.url = DEFAULT_OPTIONS.url;
	}

	let {size, ath, atv, url} = options;
	if (!Number.isFinite(ath) && !Number.isFinite(atv)) {
		ath = krpano.view.hlookat;
		atv = krpano.view.vlookat;
	}

	let aclkTimeout = 1000;
	let aclkT1 = krpano.timertick;
	let aclkWaiting = true;

	const hotspot = krpano.addhotspot(name);

	krpano.set('hotspot[' + name + '].crop', '0|0|50|50');
	krpano.set('hotspot[' + name + '].distorted', true);
	krpano.set('hotspot[' + name + '].capture', false);
	krpano.set('hotspot[' + name + '].ath', ath);
	krpano.set('hotspot[' + name + '].atv', atv);
	krpano.set('hotspot[' + name + '].scale', size / 50);
	krpano.set('hotspot[' + name + '].zorder', 99);

	let _timer;
	function updateSpinner() {
		if (_timer) {
			clearTimeout(_timer);
		}
		if (!aclkWaiting || !hotspot || hotspot.destroyed) {
			return;
		}
		if (!hotspot.visible) {
			_timer = setTimeout(updateSpinner, 100);
			return;
		}
		let dt = krpano.timertick - aclkT1;
		let f1 = dt / aclkTimeout;
		let f2 = Math.round(f1 * 16);
		let f3 = Math.min(f2, 16);
		let f4 = f3 * 50;
		let crop = f4 + '|0|50|50';
		dt = dt - 100;
		hotspot.crop = crop;
		if (dt > aclkTimeout) {
			aclkT1 = krpano.timertick;
			hotspot.crop = '0|0|50|50';
		}
		if (!aclkWaiting) {
			return;
		}
		requestAnimationFrame(updateSpinner);
	}

	function startSpinner() {
		aclkWaiting = true;
		hotspot.visible = true;
		updateSpinner();
		return hotspot;
	};
	hotspot.startSpinner = startSpinner;

	function stopSpinner() {
		aclkWaiting = false;
		hotspot.visible = false;
		return hotspot;
	};
	hotspot.stopSpinner = stopSpinner;

	function removeSpinner() {
		stopSpinner();

		delete hotspot.startSpinner;
		delete hotspot.stopSpinner;
		delete hotspot.removeSpinner;
		delete hotspot.isSpinning;

		requestAnimationFrame(() => {
			krpano && krpano.removehotspot(name);
		});
		return hotspot;
	};
	hotspot.removeSpinner = removeSpinner;

	setTimeout(() => {
		hotspot.url = url;
		hotspot.onloaded = startSpinner;
	}, 0);

	return hotspot;
}

export default SpinnerHotspot;
